import { FC, useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import { taskProps, tenderDataProps } from '../../../pages/TenderViewPage/types';
import { downloadFileFunc } from '../../../api/axiosCruds';
import { useApproveTaskMutation, useSendActivitiesMutation } from '../../../api/tenders';
import { UploadFileModal } from '../../Modals/UploadFileModal';
import { NewDocumentModal } from '../../Modals/NewDocumentModal';
import { RejectDocumentModal } from '../../Modals/RejectDocumentModal';
import Visit from '../../../assets/Visit.svg';
import deleteIcon from '../../../assets/DeleteIcon.svg';
import pendingIcon from '../../../assets/panding-circle.svg';
import SuppDocIcon from '../../../assets/SuppDocIcon.svg';
import messageGrey from '../../../assets/messageGrey.svg';
import uploadfile from '../../../assets/document.svg';
import done from '../../../assets/Done, Check.svg';
import paint from '../../../assets/paint.svg';
import i from '../../../assets/i.svg';
import downloadIcon from '../../../assets/Documents, File, Download.svg';
import ReceivedFile from '../../../assets/ReceivedFile.svg';
import edit from '../../../assets/editAdminIcon.svg';
import moment from 'moment';
import { WarningTriangle } from '../../Icons/WarningTriangle';

interface DefineSupportingDocumentTaskProps {
    data: tenderDataProps;
    role: string | null;
    setTaskId: React.Dispatch<React.SetStateAction<string | number | null>>;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    setNewDocumentModal: React.Dispatch<React.SetStateAction<boolean>>;
    taskId: string | null | number;
    messageApi: any;
    newDocumentModal: boolean;
    documentModal: boolean;
    setDeadlineModal: React.Dispatch<React.SetStateAction<boolean>>;
    setDocumentModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DesignDocumentTask: FC<DefineSupportingDocumentTaskProps> = ({
    data,
    role,
    taskId,
    setTaskId,
    messageApi,
    setTrigger,
    newDocumentModal,
    documentModal,
    setNewDocumentModal,
    setDocumentModal
}) => {
    const [approveTask, { isLoading: isLoadingApprove }] = useApproveTaskMutation();
    const [sendActivities] = useSendActivitiesMutation();
    const [isUploadModal, setIsUploadModal] = useState<boolean>(false);
    const [isDeclineModal, setIsDeclineModal] = useState<boolean>(false);
    const [isShowDeadline, setIsShowDeadline] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (role === 'school_user') {
            setIsShowDeadline(false);
        } else {
            if (data.can_update_phase) {
                setIsShowDeadline(false);
            } else {
                setIsShowDeadline(true);
            }
        }
    }, [data, role]);

    const downloadFunc = (fileId: string, taskId: number, name: string) => {
        setIsLoading(true);
        downloadFileFunc({
            tenderId: data.id,
            taskId: taskId,
            fileId: fileId
        })
            .then((response: any) => {
                downloadPDF(response, name);
            })
            .catch(() => {
                messageApi.error('Downloading Error. Check your internet connection');
            })
            .finally(() => setIsLoading(false));
    };

    const downloadPDF = (response: any, filename: any) => {
        let blob = new Blob([response.data], {
            type: response.headers['content-type']
        });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let fileName = filename.replace(/"/g, '').trim();
        link.download = fileName;
        link.target = '_blank';

        const el = document.body;
        el.appendChild(link);

        link.click();
        setTrigger((prev: boolean) => !prev);
        messageApi.success('File has been downloaded successfully');
    };

    const approveTaskFunc = async (taskId: number) => {
        try {
            const formData = {
                tenderId: data?.id,
                taskId: taskId
            };
            await approveTask(formData).unwrap();
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    const sendActivitiesFunc = async (id: number) => {
        const formData = {
            tenderId: data.id,
            taskId: id,
            data: {
                action: 'link_click'
            }
        };
        try {
            await sendActivities(formData);
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    return (
        <>
            {isShowDeadline && data?.tasks_deadline_at && role !== 'onboarding_representative' && (
                <div className={`tasks__info-wrap info-wrap `} style={{ margin: '0 0 15px 0' }}>
                    <div className="info-wrap__deadline">Task Deadline for Buyer</div>
                    <div className="info-wrap__status">{moment(data?.tasks_deadline_at).format('YYYY-MM-DD')}</div>
                </div>
            )}

            {data?.phase_tasks.length > 0 ? (
                data?.phase_tasks.map((elem: taskProps) => {
                    if (elem.action === 'design_document') {
                        if (role !== 'school_user') {
                            if (elem.status === 'pending_tr' && !elem.approved && !elem.declined) {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete green
                                    `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SuppDocIcon} />
                                                {elem?.name}
                                            </div>
                                        </div>

                                        <div className="task-complete__info-wrap">
                                            <>
                                                <div className="task-complete__wrap">
                                                    <div className="task-complete__name">Link</div>
                                                </div>
                                                <div className="task-complete__wrap">
                                                    <div className="task-complete__value">
                                                        <img src={ReceivedFile} className="upload-download-icon" />
                                                        {elem.link}
                                                    </div>
                                                </div>
                                                {elem.comments.tender_representative && (
                                                    <>
                                                        <div className="task-complete__wrap">
                                                            <div className="task-complete__name">My Comment</div>
                                                        </div>
                                                        <div className="task-complete__wrap">
                                                            <div className="task-complete__value">
                                                                {elem.comments.tender_representative}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                {role !== 'super_admin' && (
                                                    <img
                                                        src={edit}
                                                        className="task-complete__edit"
                                                        onClick={() => {
                                                            setTaskId(elem.id);
                                                            setDocumentModal(true);
                                                        }}
                                                    />
                                                )}
                                            </>
                                        </div>
                                    </div>
                                );
                            }
                            if (elem.status === 'pending_su') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete
                                `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SuppDocIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="task__pending" key={elem.id}>
                                                <img src={pendingIcon} />
                                                Pending
                                            </div>
                                        </div>

                                        <div className="task-complete__info-wrap">
                                            <>
                                                <div className="task-complete__wrap">
                                                    <div className="task-complete__name">Link</div>
                                                </div>
                                                <div className="task-complete__wrap">
                                                    <div className="task-complete__value">
                                                        <img src={ReceivedFile} className="upload-download-icon" />
                                                        {elem.link}
                                                    </div>
                                                </div>
                                                {elem.comments.tender_representative && (
                                                    <>
                                                        <div className="task-complete__wrap">
                                                            <div className="task-complete__name">My Comment</div>
                                                        </div>
                                                        <div className="task-complete__wrap">
                                                            <div className="task-complete__value">
                                                                {elem.comments.tender_representative}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        </div>
                                    </div>
                                );
                            }

                            if (elem.status === 'completed' && elem.approved) {
                                return (
                                    <>
                                        <div
                                            key={elem.id}
                                            className={`tasks__task-complete task-complete green
                                `}
                                        >
                                            <div className="task-complete__title">
                                                <div className="task-complete__title-row">
                                                    <img src={SuppDocIcon} />
                                                    {elem?.name}
                                                </div>
                                                <div className="task__btn-wrap">
                                                    <span className="task__approved-active">
                                                        <img src={done} />
                                                        Approved
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="task-complete__info">
                                                <div className="task-complete__wrap column">
                                                    <div className="task-complete__name">Received Link</div>
                                                    <div className="task-complete__value file">
                                                        <img src={ReceivedFile} className="upload-download-icon" />

                                                        <div>{elem.link}</div>
                                                    </div>
                                                </div>
                                                <div className="task-complete__wrap">
                                                    <a
                                                        href={elem.link ?? ''}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => sendActivitiesFunc(elem.id)}
                                                    >
                                                        <div className="supplier-SU__white-btn">
                                                            Open Link <img src={Visit} />
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            {elem.comments.tender_representative && (
                                                <>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value school-user">
                                                            <img src={messageGrey} />
                                                            {elem.comments.tender_representative}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </>
                                );
                            }
                            if (elem.status === 'completed' && elem.declined) {
                                return (
                                    <>
                                        <div
                                            key={elem.id}
                                            className={`tasks__task-complete task-complete yellow
                                `}
                                        >
                                            <div className="task-complete__title">
                                                <div className="task-complete__title-row">
                                                    <img src={SuppDocIcon} />
                                                    {elem?.name}
                                                </div>
                                                <div className="task-complete__title-row">
                                                    <div
                                                        className="task-complete__title-row yellow"
                                                        style={{
                                                            margin: '0 12px 0 0',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 8,
                                                            padding: '10px 0'
                                                        }}
                                                    >
                                                        <WarningTriangle color="#E3A11F" />
                                                        Change Requested
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="task-complete__info">
                                                <div className="task-complete__wrap column">
                                                    <div className="task-complete__name">Received Link</div>
                                                    <div className="task-complete__value file">
                                                        <img src={ReceivedFile} className="upload-download-icon" />

                                                        <div>{elem.link}</div>
                                                    </div>
                                                </div>
                                                <div className="task-complete__wrap">
                                                    <a
                                                        href={elem.link ?? ''}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => sendActivitiesFunc(elem.id)}
                                                    >
                                                        <div className="supplier-SU__white-btn">
                                                            Open Link <img src={Visit} />
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            {elem.comments.tender_representative && (
                                                <>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value school-user">
                                                            <img src={messageGrey} />
                                                            {elem.comments.tender_representative}
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <div className="task-complete__info-wrap">
                                                <>
                                                    {elem.comments.declined && (
                                                        <>
                                                            <div className="task-complete__wrap">
                                                                <div className="task-complete__name">
                                                                    Change request comment
                                                                </div>
                                                            </div>
                                                            <div className="task-complete__wrap">
                                                                <div className="task-complete__value">
                                                                    {elem.comments.declined}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            </div>
                                        </div>
                                    </>
                                );
                            }
                        }
                        if (role === 'school_user') {
                            if (elem.status === 'pending_su' && !elem.approved && !elem.declined) {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete
                                    `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SuppDocIcon} />
                                                {elem?.name}{' '}
                                            </div>

                                            <div className="task-complete__title-row">
                                                <Tooltip
                                                    title="To reject this activity, you need to download the document first"
                                                    overlayClassName={` ${
                                                        !elem.link_clicked
                                                            ? 'custom-tooltip-disabled'
                                                            : 'custom-tooltip'
                                                    }`}
                                                >
                                                    <div
                                                        className={`task-complete__decline ${
                                                            elem.link_clicked ? '' : 'disable'
                                                        }`}
                                                        onClick={() => {
                                                            if (elem.link_clicked) {
                                                                setTaskId(elem.id);
                                                                setIsDeclineModal(true);
                                                            }
                                                        }}
                                                    >
                                                        Request Changes
                                                    </div>
                                                </Tooltip>
                                                <Tooltip
                                                    title="To approve this activity, you need to download the document first"
                                                    overlayClassName={` ${
                                                        !elem.link_clicked
                                                            ? 'custom-tooltip-disabled'
                                                            : 'custom-tooltip'
                                                    }`}
                                                >
                                                    <div
                                                        className={`task-complete__approved ${
                                                            !elem.link_clicked ? 'disabled-blue-button' : ''
                                                        }`}
                                                        onClick={() => {
                                                            if (elem.link_clicked && !isLoadingApprove) {
                                                                approveTaskFunc(elem.id);
                                                            }
                                                        }}
                                                    >
                                                        Approve
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="task-complete__info">
                                            <div className="task-complete__wrap column">
                                                <div className="task-complete__name">Received Link</div>
                                                <div className="task-complete__value file">
                                                    <img src={ReceivedFile} className="upload-download-icon" />
                                                    <div>{elem.link}</div>
                                                </div>
                                            </div>

                                            <div className="task-complete__wrap">
                                                <a
                                                    href={elem.link ?? ''}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    onClick={() => sendActivitiesFunc(elem.id)}
                                                >
                                                    <div className="supplier-SU__white-btn">
                                                        Open Link <img src={Visit} />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        {elem.comments.tender_representative && (
                                            <>
                                                <div className="task-complete__wrap">
                                                    <div className="task-complete__value school-user">
                                                        <img src={messageGrey} />
                                                        {elem.comments.tender_representative}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                );
                            }

                            if (elem.status === 'pending_su' && elem.declined) {
                                return (
                                    <>
                                        <div
                                            key={elem.id}
                                            className={`tasks__task-complete task-complete yellow
                                `}
                                        >
                                            <div className="task-complete__title">
                                                <div className="task-complete__title-row">
                                                    <img src={SuppDocIcon} />
                                                    {elem?.name}
                                                </div>
                                                <div className="task-complete__title-row">
                                                    <div
                                                        className="task-complete__title-row yellow"
                                                        style={{
                                                            margin: '0 12px 0 0',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 8,
                                                            padding: '10px 0'
                                                        }}
                                                    >
                                                        <WarningTriangle color="#E3A11F" />
                                                        Change Requested
                                                    </div>
                                                    <div
                                                        className={`task-complete__approved ${
                                                            !elem.link_clicked ? 'disabled-blue-button' : ''
                                                        }`}
                                                        onClick={() => {
                                                            if (elem.link_clicked && !isLoadingApprove) {
                                                                approveTaskFunc(elem.id);
                                                            }
                                                        }}
                                                    >
                                                        Approve
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="task-complete__info">
                                                <div className="task-complete__wrap column">
                                                    <div className="task-complete__name">Received Link</div>
                                                    <div className="task-complete__value file">
                                                        <img src={ReceivedFile} className="upload-download-icon" />

                                                        <div>{elem.link}</div>
                                                    </div>
                                                </div>
                                                <div className="task-complete__wrap">
                                                    <a
                                                        href={elem.link ?? ''}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => sendActivitiesFunc(elem.id)}
                                                    >
                                                        <div className="supplier-SU__white-btn">
                                                            Open Link <img src={Visit} />
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            {elem.comments.tender_representative && (
                                                <>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value school-user">
                                                            <img src={messageGrey} />
                                                            {elem.comments.tender_representative}
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <div className="task-complete__info-wrap">
                                                <>
                                                    {elem.comments.declined && (
                                                        <>
                                                            <div className="task-complete__wrap">
                                                                <div className="task-complete__name">My Comment</div>
                                                            </div>
                                                            <div className="task-complete__wrap">
                                                                <div className="task-complete__value">
                                                                    {elem.comments.declined}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            </div>
                                        </div>
                                    </>
                                );
                            }
                            if (
                                elem.status === 'pending_su' &&
                                elem.declined &&
                                !elem?.files?.school_user?.[0]?.name &&
                                elem.comments.school_user
                            ) {
                                return (
                                    <>
                                        <div
                                            key={elem.id}
                                            className={`tasks__task-complete task-complete yellow
                                `}
                                        >
                                            <div className="task-complete__title">
                                                <div className="task-complete__title-row">
                                                    <img src={SuppDocIcon} />
                                                    {elem?.name}
                                                </div>
                                                <div className="task-complete__title-row">
                                                    <div
                                                        className="task-complete__title-row yellow"
                                                        style={{
                                                            margin: '0 0 0 16px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 8,
                                                            padding: '10px 0'
                                                        }}
                                                    >
                                                        <WarningTriangle color="#E3A11F" />
                                                        Change Requested
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="task-complete__info">
                                                <div className="task-complete__wrap column">
                                                    <div className="task-complete__name">Received File</div>
                                                    <div className="task-complete__value file">
                                                        <img src={ReceivedFile} className="upload-download-icon" />

                                                        {elem.files.tender_representative[0]?.name}
                                                    </div>
                                                </div>
                                                <div className="task-complete__wrap">
                                                    <div
                                                        className={`task-complete__download-btn `}
                                                        onClick={() => {
                                                            if (!isLoading) {
                                                                downloadFunc(
                                                                    elem.files.tender_representative[0]?.uuid,
                                                                    elem.id,
                                                                    elem.files.tender_representative[0]?.name
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        <img src={downloadIcon} className="upload-download-icon" />
                                                        Download
                                                    </div>
                                                </div>
                                            </div>
                                            {elem.comments.files[elem.files.tender_representative[0]?.uuid] && (
                                                <>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value school-user">
                                                            <img src={messageGrey} />
                                                            {
                                                                elem.comments.files[
                                                                    elem.files.tender_representative[0]?.uuid
                                                                ]
                                                            }
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            {elem.comments.school_user && (
                                                <div className="task-complete__info-wrap">
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__name">My Comment</div>
                                                    </div>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value">
                                                            {elem.comments.school_user}
                                                        </div>
                                                    </div>
                                                    <img
                                                        src={deleteIcon}
                                                        className="task-complete__edit"
                                                        onClick={() => {
                                                            setTaskId(elem.id);
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                );
                            }

                            if (elem.status === 'pending_su' && elem.approved) {
                                return (
                                    <>
                                        {' '}
                                        <div
                                            key={elem.id}
                                            className={`tasks__task-complete task-complete green
                                `}
                                        >
                                            <div className="task-complete__title">
                                                <div className="task-complete__title-row">
                                                    <img src={SuppDocIcon} />
                                                    {elem?.name}{' '}
                                                </div>

                                                <div className="task-complete__title-row">
                                                    <div
                                                        className={`task-complete__decline ${
                                                            elem.link_clicked ? '' : 'disable'
                                                        }`}
                                                        onClick={() => {
                                                            if (elem.link_clicked) {
                                                                setTaskId(elem.id);
                                                                setIsDeclineModal(true);
                                                            }
                                                        }}
                                                    >
                                                        Change request
                                                    </div>

                                                    <div className="task-complete__approved-active">
                                                        <img src={done} />
                                                        Approved
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="task-complete__info">
                                                <div className="task-complete__wrap column">
                                                    <div className="task-complete__name">Received Link</div>
                                                    <div className="task-complete__value file">
                                                        <img src={ReceivedFile} className="upload-download-icon" />
                                                        <div>{elem.link}</div>
                                                    </div>
                                                </div>

                                                <div className="task-complete__wrap">
                                                    <a
                                                        href={elem.link ?? ''}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => sendActivitiesFunc(elem.id)}
                                                    >
                                                        <div className="supplier-SU__white-btn">
                                                            Open Link <img src={Visit} />
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            {elem.comments.tender_representative && (
                                                <>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value school-user">
                                                            <img src={messageGrey} />
                                                            {elem.comments.tender_representative}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </>
                                );
                            }
                            if (elem.status === 'completed' && elem.approved) {
                                return (
                                    <>
                                        <div
                                            key={elem.id}
                                            className={`tasks__task-complete task-complete green
                                `}
                                        >
                                            <div className="task-complete__title">
                                                <div className="task-complete__title-row">
                                                    <img src={SuppDocIcon} />
                                                    {elem?.name}{' '}
                                                </div>

                                                <div className="task-complete__title-row">
                                                    <div className="task-complete__approved-active">
                                                        <img src={done} />
                                                        Approved
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="task-complete__info">
                                                <div className="task-complete__wrap column">
                                                    <div className="task-complete__name">Received Link</div>
                                                    <div className="task-complete__value file">
                                                        <img src={ReceivedFile} className="upload-download-icon" />
                                                        <div>{elem.link}</div>
                                                    </div>
                                                </div>

                                                <div className="task-complete__wrap">
                                                    <a
                                                        href={elem.link ?? ''}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => sendActivitiesFunc(elem.id)}
                                                    >
                                                        <div className="supplier-SU__white-btn">
                                                            Open Link <img src={Visit} />
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            {elem.comments.tender_representative && (
                                                <>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value school-user">
                                                            <img src={messageGrey} />
                                                            {elem.comments.tender_representative}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </>
                                );
                            }
                            if (elem.status === 'completed' && elem.declined) {
                                return (
                                    <>
                                        <div
                                            key={elem.id}
                                            className={`tasks__task-complete task-complete yellow
                                `}
                                        >
                                            <div className="task-complete__title">
                                                <div className="task-complete__title-row">
                                                    <img src={SuppDocIcon} />
                                                    {elem?.name}
                                                </div>
                                                <div className="task-complete__title-row">
                                                    <div
                                                        className="task-complete__title-row yellow"
                                                        style={{
                                                            margin: '0 12px 0 0',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 8,
                                                            padding: '10px 0'
                                                        }}
                                                    >
                                                        <WarningTriangle color="#E3A11F" />
                                                        Change Requested
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="task-complete__info">
                                                <div className="task-complete__wrap column">
                                                    <div className="task-complete__name">Received Link</div>
                                                    <div className="task-complete__value file">
                                                        <img src={ReceivedFile} className="upload-download-icon" />

                                                        <div>{elem.link}</div>
                                                    </div>
                                                </div>
                                                <div className="task-complete__wrap">
                                                    <a
                                                        href={elem.link ?? ''}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={() => sendActivitiesFunc(elem.id)}
                                                    >
                                                        <div className="supplier-SU__white-btn">
                                                            Open Link <img src={Visit} />
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            {elem.comments.tender_representative && (
                                                <>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value school-user">
                                                            <img src={messageGrey} />
                                                            {elem.comments.tender_representative}
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <div className="task-complete__info-wrap">
                                                <>
                                                    {elem.comments.declined && (
                                                        <>
                                                            <div className="task-complete__wrap">
                                                                <div className="task-complete__name">My Comment</div>
                                                            </div>
                                                            <div className="task-complete__wrap">
                                                                <div className="task-complete__value">
                                                                    {elem.comments.declined}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            </div>
                                        </div>
                                    </>
                                );
                            }
                            if (elem.status === 'need_resend_tr') {
                                return (
                                    <>
                                        {' '}
                                        <div
                                            key={elem.id}
                                            className={`tasks__task-complete task-complete 
                                `}
                                        >
                                            <div className="task-complete__title">
                                                <div className="task-complete__title-row">
                                                    <img src={SuppDocIcon} />
                                                    {elem?.name}
                                                </div>
                                                <div className="task-complete__title-row">
                                                    <div className="task__pending" key={elem.id}>
                                                        <img src={pendingIcon} />
                                                        Pending
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="task-complete__info">
                                                <div className="task-complete__wrap column">
                                                    <div className="task-complete__name">Received File</div>
                                                    <div className="task-complete__value file">
                                                        <img src={ReceivedFile} className="upload-download-icon" />

                                                        {elem.files.tender_representative[0]?.name}
                                                    </div>
                                                </div>

                                                <div className="task-complete__wrap">
                                                    <div
                                                        className={`task-complete__download-btn `}
                                                        onClick={() => {
                                                            if (!isLoading) {
                                                                downloadFunc(
                                                                    elem.files.tender_representative[0]?.uuid,
                                                                    elem.id,
                                                                    elem.files.tender_representative[0]?.name
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        <img src={downloadIcon} className="upload-download-icon" />
                                                        Download
                                                    </div>
                                                </div>
                                            </div>
                                            {elem.comments.files[elem.files.tender_representative[0]?.uuid] && (
                                                <>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value school-user">
                                                            <img src={messageGrey} />
                                                            {
                                                                elem.comments.files[
                                                                    elem.files.tender_representative[0]?.uuid
                                                                ]
                                                            }
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            {!elem.files.school_user ? (
                                                <>
                                                    {elem.comments.school_user && (
                                                        <div className="task-complete__info-wrap">
                                                            <div className="task-complete__wrap">
                                                                <div className="task-complete__name">My Comment</div>
                                                            </div>
                                                            <div className="task-complete__wrap">
                                                                <div className="task-complete__value">
                                                                    {elem.comments.school_user}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                ''
                                            )}

                                            {elem?.files?.school_user?.[0]?.name && (
                                                <div className="task-complete__info-wrap">
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__name">Uploaded File</div>
                                                    </div>
                                                    <div className="task-complete__wrap">
                                                        <div className="task-complete__value file">
                                                            <img src={ReceivedFile} className="upload-download-icon" />
                                                            {elem?.files?.school_user?.[0]?.name}
                                                        </div>
                                                    </div>

                                                    <>
                                                        {elem.comments.files[elem.files.school_user[0]?.uuid] && (
                                                            <>
                                                                <div className="task-complete__wrap">
                                                                    <div className="task-complete__name">
                                                                        My Comment
                                                                    </div>
                                                                </div>
                                                                <div className="task-complete__wrap">
                                                                    <div className="task-complete__value">
                                                                        {
                                                                            elem.comments.files[
                                                                                elem.files.school_user[0]?.uuid
                                                                            ]
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                );
                            }
                        }
                    }
                })
            ) : (
                <>
                    {role === 'tender_representative' && (
                        <>
                            <div className="add-first-document">
                                <div className="add-first-document__wrapper">
                                    <img src={i} className="add-first-document__image" />
                                    <div>
                                        At this stage, you need to specify the documents that the Buyer expects from you
                                    </div>
                                </div>
                                <div
                                    className="add-first-document__add"
                                    onClick={() => {
                                        setNewDocumentModal(true);
                                    }}
                                >
                                    <img src={uploadfile} className="add-first-document__image" />
                                    Add Document
                                </div>
                            </div>
                        </>
                    )}
                    {role === 'school_user' && (
                        <div className="noTasks">
                            <img src={paint} />
                            <div className="noTasks__title">Welcome to the Design Phase!</div>
                            <div className="noTasks__subtitle">
                                Watch this space - new tasks for you will be posted here as they become available.
                            </div>
                        </div>
                    )}
                </>
            )}

            {newDocumentModal && (
                <NewDocumentModal
                    openModal={newDocumentModal}
                    setOpenModal={setNewDocumentModal}
                    data={data}
                    taskId={taskId}
                    messageApi={messageApi}
                    setTrigger={setTrigger}
                    type="create"
                />
            )}
            {documentModal && (
                <NewDocumentModal
                    openModal={documentModal}
                    setOpenModal={setDocumentModal}
                    data={data}
                    taskId={taskId}
                    messageApi={messageApi}
                    setTrigger={setTrigger}
                    type="update"
                />
            )}
            {isUploadModal && (
                <UploadFileModal
                    openModal={isUploadModal}
                    setOpenModal={setIsUploadModal}
                    data={data}
                    taskId={taskId}
                    messageApi={messageApi}
                    setTrigger={setTrigger}
                    title="Supporting Document"
                    subtitle=""
                />
            )}

            {isDeclineModal && (
                <RejectDocumentModal
                    openModal={isDeclineModal}
                    setOpenModal={setIsDeclineModal}
                    data={data}
                    setTrigger={setTrigger}
                    taskId={taskId}
                    title="Request Changes to Document"
                />
            )}
        </>
    );
};
